// import $ from 'jquery'
console.log( '%c Aden Logistics %c 2026.30.5 ', 'background:#1a1a1a;color:#ffd100;font-weight:bold;padding:2px 4px;', 'background:#ffd100;color:#1a1a1a;font-weight:bold;padding:2px 4px;' )
import './_components'
import externalLinks from './_utils/externalLinks'
import deviceDetect from './_utils/deviceDetect'
import handleFlyoutMenu from './_components/handleFlyoutMenu'
import initMenus from './_components/menu/setup'
import showHideMenu from './_components/showHideMenu'
import tabs from './_components/tabs'
import handleMenuFooterLinks from './handleMenuFooterLinks'
import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import Autoplay from 'embla-carousel-autoplay'
import dropdown from './_components/dropdown'
import fixWidows from './_utils/fixWidows'
import { closeAllSelect, initializeCustomSelects } from './_components/select/select'

initializeCustomSelects( 'services' )

// window.$ = $
// window.jQuery = $

const emblaNodes = <NodeListOf<HTMLElement>>document.querySelectorAll( '.embla' )
if ( emblaNodes ) {
  emblaNodes.forEach( emblaNode => {
    const viewportNode = <HTMLElement>emblaNode.querySelector( '.embla__viewport' )
    // const options: EmblaOptionsType = {
    //   loop: true,
    //   slidesToScroll: 'auto',
    //   containScroll: 'trimSnaps'
    // }
    const options = { loop: true }
    const emblaApi = EmblaCarousel( viewportNode, options, [WheelGesturesPlugin()] )
    console.log( emblaApi.slideNodes() )
  } )
}

const setupCloseButtons = ( modal: HTMLDialogElement ) => {
  const closeButtons = modal.querySelectorAll( '[data-modal-close]' )
  closeButtons.forEach( closeButton => {
    closeButton.addEventListener( 'click', () => {
      modal.classList.add( 'visually-hidden' )
      setTimeout( () => {
        modal.close()
      }, 250 )
    } )
  } )
}

/**
 * Handle revealing modals for
 */
const handleModals = () => {
  const modalTriggers = <NodeListOf<HTMLElement>>document.querySelectorAll( '[data-modal-open]' )
  modalTriggers.forEach( modalTrigger => {
    const modal = <HTMLDialogElement>document.querySelector( `#${modalTrigger.dataset.modalOpen}` as string )
    if ( modal ) {
      modal.classList.add( 'visually-hidden' )
      modalTrigger.addEventListener( 'click', () => {
        modal.showModal()
        setTimeout( () => modal.classList.remove( 'visually-hidden' ), 50 )
        modal.addEventListener( 'click', function( event ) { event.target === this && this.close() } )
        setupCloseButtons( modal )
      } )
    } else {
      console.warn( `A <dialog> does not exist to match the trigger "${modalTrigger.dataset.modalOpen}".` )
    }
  } )
}

/**
 * Add the career listed to a hidden input in
 * the careers modal.
 */
const addCareerValueToFormInput = () => {
  const positionLinks = <NodeListOf<HTMLElement>>document.querySelectorAll( '[data-position]' )
  positionLinks.forEach( link => {
    link.addEventListener( 'click', () => {
      if ( link.dataset.position ) {
        /**
         * This unfortunately is the most immediate HTML way of accessing the field,
         * and may break if the form fields are updated.
         */
        const hiddenCareerField = <HTMLInputElement>document.querySelector( '#gform_2 #input_2_7' )
        if ( hiddenCareerField ) hiddenCareerField.value = link.dataset.position
      }
    } )
  } )
}

addCareerValueToFormInput()

handleModals()

// @ts-ignore: TS2339: Property does not exist on type
// jQuery( document ).foundation()
deviceDetect()
externalLinks()

const { init: initTabs } = tabs()
initMenus()

showHideMenu()
handleFlyoutMenu()
initTabs()
handleMenuFooterLinks()
dropdown()
fixWidows()

gform.initializeOnLoaded( function() {
  gformInitSpinner( 1, 'https://aden-logistics.local/wp-content/plugins/gravityforms/images/spinner.svg', true )
  jQuery( '#gform_ajax_frame_1' ).on( 'load', function() {
      const contents = jQuery( this ).contents().find( '*' ).html()
      const is_postback = contents.indexOf( 'GF_AJAX_POSTBACK' ) >= 0
      if ( !is_postback ) {
          return
      }
      const form_content = jQuery( this ).contents().find( '#gform_wrapper_1' )
      const is_confirmation = jQuery( this ).contents().find( '#gform_confirmation_wrapper_1' ).length > 0
      const is_redirect = contents.indexOf( 'gformRedirect(){' ) >= 0
      const is_form = form_content.length > 0 && !is_redirect && !is_confirmation
      const mt = parseInt( jQuery( 'html' ).css( 'margin-top' ), 10 ) + parseInt( jQuery( 'body' ).css( 'margin-top' ), 10 ) + 100
      if ( is_form ) {
          jQuery( '#gform_wrapper_1' ).html( form_content.html() )
          if ( form_content.hasClass( 'gform_validation_error' ) ) {
              jQuery( '#gform_wrapper_1' ).addClass( 'gform_validation_error' )
          } else {
              jQuery( '#gform_wrapper_1' ).removeClass( 'gform_validation_error' )
          }
          setTimeout( function() { /* delay the scroll by 50 milliseconds to fix a bug in chrome */
              jQuery( document ).scrollTop( jQuery( '#gform_wrapper_1' ).offset().top - mt )
          }, 50 )
          if ( window['gformInitDatepicker'] ) {
              gformInitDatepicker()
          }
          if ( window['gformInitPriceFields'] ) {
              gformInitPriceFields()
          }
          var current_page = jQuery( '#gform_source_page_number_1' ).val()
          gformInitSpinner( 1, 'https://aden-logistics.local/wp-content/plugins/gravityforms/images/spinner.svg', true )
          jQuery( document ).trigger( 'gform_page_loaded', [1, current_page] )
          window['gf_submitting_1'] = false
      } else if ( !is_redirect ) {
          let confirmation_content = jQuery( this ).contents().find( '.GF_AJAX_POSTBACK' ).html()
          if ( !confirmation_content ) {
              confirmation_content = contents
          }
          setTimeout( function() {
              jQuery( '#gform_wrapper_1' ).replaceWith( confirmation_content )
              jQuery( document ).scrollTop( jQuery( '#gf_1' ).offset().top - mt )
              jQuery( document ).trigger( 'gform_confirmation_loaded', [1] )
              window['gf_submitting_1'] = false
              wp.a11y.speak( jQuery( '#gform_confirmation_message_1' ).text() )
          }, 50 )
      } else {
          jQuery( '#gform_1' ).append( contents )
          if ( window['gformRedirect'] ) {
              gformRedirect()
          }
      }
      jQuery( document ).trigger( 'gform_post_render', [1, current_page] )
      gform.utils.trigger( {
          event: 'gform/postRender',
          native: false,
          data: {
              formId: 1,
              currentPage: current_page
          }
      } )
  } )
} )

/**
 * Home Page Speedometer Change
 */
function simulateSpeedometerChange() {
  const speedometer = document.getElementById( 'speedometer' )
  if ( !speedometer ) return

  let speed = 65
  speedometer.textContent = speed.toString()

  // Function to update speedometer
  const updateSpeed = ( newSpeed: number ) => {
    speedometer.textContent = newSpeed.toString()
  }

  // Increment speed
  const incrementSpeed = () => {
    if ( speed < 67 ) {
      updateSpeed( ++speed )
      setTimeout( incrementSpeed, 1000 ) // Continue incrementing after 1 second
    } else {
      decrementSpeed() // Start decrementing
    }
  }

  // Decrement speed
  const decrementSpeed = () => {
    if ( speed > 65 ) {
      updateSpeed( --speed )
      setTimeout( decrementSpeed, 1000 ) // Continue decrementing after 1 second
    } else {
      setTimeout( simulateSpeedometerChange, 1000 ) // Restart the cycle
    }
  }

  incrementSpeed() // Start the cycle
}

/**
 * Adjust Driving Scene Video Size
 */
function adjustDrivingSceneVideoSize() {
  const innerWrapper = document.querySelector( '#driving-scene .inner-wrapper' ) as HTMLDivElement
  const backgroundVideo = document.querySelector( '.background-video video' ) as HTMLVideoElement
  const backgroundVideoVignette = document.querySelector( '.background-video .vignette' ) as HTMLDivElement

  if ( innerWrapper && backgroundVideo ) {
    const { width, height } = innerWrapper.getBoundingClientRect()
    backgroundVideo.style.width = width + 'px'
    backgroundVideo.style.height = height + 'px'
    backgroundVideoVignette.style.width = width + 'px'
    backgroundVideoVignette.style.height = height + 'px'
  }
}

/**
 * Handle the interactivity on the home page.
 */
const initHomePageInteractivity = () => {
  const body = document.body as HTMLBodyElement
  const drivingScene = document.querySelector( '#driving-scene' ) as HTMLElement
  const honkElement = 'g#Honk rect'
  const honkSound = new Audio( '/wp-content/themes/AdenLogistics/assets/sounds/DW9Z3QP-semi-truck-horn-20339_01.mp3' )

  // If we are on the home page where the body has the `page-template-home` class
  if ( body.classList.contains( 'page-template-home' ) ) {

    // Event delegation for mouseenter and mouseleave
    document.addEventListener( 'mouseover', ( event ) => {
      if ( event.target.closest( honkElement ) ) {
        drivingScene.classList.add( 'honk-hover' )
      } else {
        drivingScene.classList.remove( 'honk-hover' )
      }
    } )

    // Event delegation for click
    document.addEventListener( 'click', ( event ) => {
      if ( event.target.closest( honkElement ) ) {
        console.log( 'Honk was clicked', event )
        honkSound.play()
      }
    } )

    simulateSpeedometerChange()

    // Adjust the video size on load
    window.addEventListener( 'load', adjustDrivingSceneVideoSize )

    // Adjust the video size on window resize
    window.addEventListener( 'resize', adjustDrivingSceneVideoSize )

  }

}

initHomePageInteractivity()

document.addEventListener( 'DOMContentLoaded', () => {
  // const equipmentItems = document.querySelector<HTMLElement>( '.equipment-items' )
  // const trees = document.querySelector<HTMLElement>( '.slide-trees' )
  // const mountains = document.querySelector<HTMLElement>( '.slide-mountains' )
  // // translateZ(-100px) translateX(-200px) translateY(200px)
  // // console.log( equipmentItems, equipmentItems.clientWidth )
  // // trees.style.width = `${equipmentItems.clientWidth}px`
  // if ( equipmentItems && mountains ) {
  // const width = equipmentItems.clientWidth + 400
  // // const width2 = equipmentItems.clientWidth + 200
  // mountains.style.width = `${width}px`
  // // trees.style.width = `${width2}px`
  // // mountains.style.transform = `translateZ(-100px) translateX(-200px) translateY(200px)`
  // mountains.style.transform = 'translateZ(-100px) translateX(-200px) translateY(200px)'
  // }
  // trees.style.transform = `translateZ(-50px) translateX(-500px) translateY(150px)`
  // container.style.overflow = 'hidden'
} )